// CardSkeleton.jsx
import React from "react";
import ContentLoader from "react-content-loader";

function CardSkeleton({ width = 200, height = 300 }) {
  return (
    <ContentLoader
      speed={2}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#333333ff"
      foregroundColor="#414141ff"
      style={{ borderRadius: "12px" }}
    >
      <rect x="0" y="0" rx="8" ry="8" width={width} height={height} />
    </ContentLoader>
  );
}

export default CardSkeleton;
